import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';

import CheckSuccess from '../../../shared/components/Icons/CheckSuccess';
import containerWidth from '../../../shared/helpers/containerWidth';
import getEnvironmentSuffix from '../../../shared/helpers/getEnvironmentSuffix';

import TopHeader from '../TopHeader/TopHeader';
import TopNavigation from '../TopNavigation/TopNavigation';

import './ConfirmationScreen.scss';

const ConfirmationScreen = ({ match }) => (
  <div className="container-fluid confirmation-page">
    <TopNavigation stepNumber={5} />
    <TopHeader />
    <div className="row">
      <div className={`${containerWidth} text-center`}>
        <div className="mb-3">
          <CheckSuccess className="confirmation-page__icon" />
        </div>
        <h3 className="confirmation-page__message">Thank you!</h3>
        <h3 className="confirmation-page__message">
          Your request was submitted.
        </h3>
        <div className="d-flex justify-content-center mt-5">
          <a
            href={`/${match?.params?.companyName}/`}
            className="btn btn-outline-success confirmation-page__success-outline"
          >
            Order Another
          </a>
          {window.isAuthenticated && (
            <a
              href={`http://connect${getEnvironmentSuffix()}.anow.com/orders/${
                match?.params?.companyName
              }`}
              className="btn btn-success confirmation-page__success ml-5"
            >
              View Status
            </a>
          )}
        </div>
      </div>
    </div>
  </div>
);

ConfirmationScreen.propTypes = {
  // eslint-disable-next-line react/no-typos
  match: ReactRouterPropTypes.match.isRequired,
};
ConfirmationScreen.defaultProps = {};

export default ConfirmationScreen;
